import { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import React from 'react';
import ContactSection from "./sections/ContactSection";
import Intro from "./sections/Intro";
import GreenCube from "./sections/GreenCube";
import Montelo from "./sections/Montelo";
import LanguageToggle from "../components/LanguageToggle";
import { useLanguage } from "../contexts/LanguageContext";


const Home: React.FC = () => {
    const { t } = useLanguage();
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="w-screen h-screen text-white flex flex-col justify-between font-[Verdana]">
            {/* HEADER */}
            <header className="bg-[#FFFFFF]/80 backdrop-blur-lg shadow-md flex justify-between items-center px-6 py-4 md:px-16 fixed top-0 left-0 w-full z-50">

                {/* Left: Navigation links */}
                <img src="/images/logo_small.png" className="h-10" />

                {/* Center: Navigation links */}
                <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 space-x-8 text-sm font-light items-center">
                    <a href="#inicio" className="hover:underline text-[#282A2A] transition duration-800">
                        {t('navigation.home')}
                    </a>
                    <a href="#greencube" className="hover:underline text-[#282A2A] transition duration-800">
                        {t('navigation.greencube')}
                    </a>
                    <a href="#montelo" className="hover:underline text-[#282A2A] transition duration-800">
                        {t('navigation.montelo')}
                    </a>
                </div>

                {/* Right: Language toggle and Contact button (desktop only)*/}
                <div className="hidden md:flex items-center gap-4">
                    <LanguageToggle />
                    <a
                        href="#contact"
                        className="bg-[#83C441] text-white py-2 px-4 rounded hover:bg-lime-600 transition duration-200"
                    >
                        {t('navigation.contactButton')}
                    </a>
                </div>

                {/* Mobile: Language toggle and menu button */}
                <div className="flex md:hidden items-center gap-4">
                    <LanguageToggle />
                    <button
                        className="text-[#282A2A]"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        {menuOpen ? <HiX size={28} /> : <HiMenu size={28} />}
                    </button>
                </div>

                {/* Mobile dropdown menu */}
                {menuOpen && (
                    <div className=" absolute top-[72px] right-0 w-full bg-[#FFFFFF]/90 backdrop-blur-lg shadow-md flex flex-col items-start py-3 md:hidden z-50">
                        <a href="#inicio" className="text-[#282A2A] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block">{t('navigation.home')}</span>
                        </a>
                        <a href="#greencube" className="text-[#282A2A] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block">{t('navigation.greencube')}</span>
                        </a>
                        <a href="#montelo" className="text-[#282A2A] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block">{t('navigation.montelo')}</span>
                        </a>
                        <a href="#contacto" className="text-[#282A2A] hover:underline w-full text-left hover:bg-[#83C441]">
                            <span className="pl-8 py-2 inline-block block">{t('navigation.contact')}</span>
                        </a>
                    </div>
                )}

            </header>

            {/* BODY */}
            <main className="bg-[#282A2A] flex flex-col items-center text-center px-16 p-10">
                <Intro />

                <GreenCube />

                <Montelo />

                <ContactSection />


            </main >

            {/* FOOTER */}
            <footer className="bg-[#282A2A] py-6 flex justify-center px-16">
                <p className="text-sm text-[#ffffff]/80 ">© 2021 Green Bull Group. {t('footer.rightsReserved')}</p>
            </footer>


        </div >
    );
};

export default Home;







